export default __webpack_public_path__ + "static/media/border.aea777e1.png";